import './setupResizeObserverDevPatch';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import { configureStore } from './redux/store';

// Canonical host is apex; www can break CORS for API calls (public app config, auth).
if (typeof window !== 'undefined' && window.location.hostname === 'www.prove-it-to.me') {
    const { pathname, search, hash } = window.location;
    window.location.replace(`https://prove-it-to.me${pathname}${search}${hash}`);
} else {
    ReactDOM.render(
        <Provider store={configureStore()}>
            <App />
        </Provider>,
        document.getElementById('root')
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: http://bit.ly/CRA-PWA
    serviceWorker.unregister();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
